module.exports = __webpack_public_path__ + "img/29.e55cb0d5.jpg";